import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface BerthPlanViewToggleProps {
  isTableView: boolean;
  onTableViewChange: (isTableView: boolean) => void;
}

/** Switches a ship-visit section between the Berth Plan and a table. */
const BerthPlanViewToggle: FC<BerthPlanViewToggleProps> = ({
  isTableView,
  onTableViewChange,
}) => {
  const { t } = useTranslation();

  return (
    <div
      role='group'
      aria-label={t('berthPlan.view.label')}
      className='inline-flex rounded-md bg-muted p-1'>
      <Button
        size='sm'
        variant={isTableView ? 'ghost' : 'outline'}
        aria-pressed={!isTableView}
        className='h-8'
        onClick={() => {
          onTableViewChange(false);
        }}>
        {t('berthPlan.view.chart')}
      </Button>
      <Button
        size='sm'
        variant={isTableView ? 'outline' : 'ghost'}
        aria-pressed={isTableView}
        className='h-8'
        onClick={() => {
          onTableViewChange(true);
        }}>
        {t('berthPlan.view.table')}
      </Button>
    </div>
  );
};

export default BerthPlanViewToggle;
